import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { setupDefinitions } from '@irembo-andela/irembogov3-common';

// setup custom definitions to embed in NodeJS
setupDefinitions();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => {
    /* TODO: Better error handling for error codes */
  });
